<template>
  <AccountIcon :image-url="imageUrl" :size="40" />
</template>
<script>
import AccountIcon from './AccountIcon.vue'
export default {
  components: { AccountIcon },
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
